import { RestArray } from '@databases/types/confluence';

export const STANDARD_PAGINATION_LIMIT = 200;

/**
 * Combine results pages in the format returned by /rest/api/content and some other resources.
 * @param fn function that makes the query, either for the initial request or the follow-up requests if `nextUrl` is provided
 * @return {Promise<*>} resolved with the combined list of results
 */
export async function* nextPagination<T>(
  fn: (nextUrl?: string) => Promise<RestArray<T>>,
  { firstPage, limit }: { firstPage?: RestArray<T>; limit?: number } = {}
): AsyncGenerator<T, void, void> {
  let number = 0;
  let nextUrl: string | undefined = undefined;
  do {
    const page: RestArray<T> = !nextUrl && firstPage ? firstPage : await fn(nextUrl);
    if (page.results.length === 0) {
      break;
    }

    for (const result of page.results) {
      yield result;

      if (limit && ++number >= limit) {
        return;
      }
    }
    nextUrl = page._links.next;
  } while (nextUrl);
}
